// @ts-nocheck
import { apiRequest } from "../../../services/apiService";
import {
  ATTACH_FILE_TO_CONTRACT_REQUEST,
  DISCARD_CONTRACT_FAILURE,
  DISCARD_CONTRACT_REQUEST,
  DISCARD_CONTRACT_SUCCESS,
  GET_ALL_CONTRACTS_FAILURE,
  GET_ALL_CONTRACTS_REQUEST,
  GET_ALL_CONTRACTS_SUCCESS,
  GET_ALL_NEW_CONTRACTS_REQUEST,
  GET_ALL_NEW_CONTRACTS_FAILURE,
  GET_ALL_NEW_CONTRACTS_SUCCESS,
  GET_UNDER_REVIEW_CONTRACTS_REQUEST,
  GET_UNDER_REVIEW_CONTRACTS_FAILURE,
  GET_UNDER_REVIEW_CONTRACTS_SUCCESS,
  GET_ALL_VERIFIED_CONTRACTS_FAILURE,
  GET_ALL_VERIFIED_CONTRACTS_REQUEST,
  GET_ALL_VERIFIED_CONTRACTS_SUCCESS,
  ADD_NEW_CONTRACT_REQUEST,
  ADD_NEW_CONTRACT_FAILURE,
  ADD_NEW_CONTRACT_SUCCESS,
  EDIT_CONTRACT_REQUEST,
  EDIT_CONTRACT_SUCCESS,
  EDIT_CONTRACT_FAILURE,
  ATTACH_FILE_TO_CONTRACT_SUCCESS,
  ATTACH_FILE_TO_CONTRACT_FAILURE,
  ADD_SIGNATURE_REQUEST,
  ADD_SIGNATURE_SUCCESS,
  ADD_SIGNATURE_FAILURE,
  DELETE_SIGNATURE_REQUEST,
  DELETE_SIGNATURE_SUCCESS,
  DELETE_SIGNATURE_FAILURE,
  EDIT_SIGNATURE_FAILURE,
  EDIT_SIGNATURE_SUCCESS,
  EDIT_SIGNATURE_REQUEST,
  GET_SIGNATURE_REQUEST,
  GET_SIGNATURE_SUCCESS,
  GET_SIGNATURE_FAILURE,
  ADD_SIGNATURE_TO_CONTRACT_SUCCESS,
  ADD_SIGNATURE_TO_CONTRACT_REQUEST,
  ADD_SIGNATURE_TO_CONTRACT_FAILURE,
  UPDATE_CONTRACT_STATUS_REQUEST,
  UPDATE_CONTRACT_STATUS_SUCCESS,
  UPDATE_CONTRACT_STATUS_FAILURE,
} from "../../constants/contract/contract";
import { alertDialogAciton } from "../auth";

/**
 * get all contracts
 */
export const getAllContractAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_ALL_CONTRACTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getDocuSigns",
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({ type: GET_ALL_CONTRACTS_SUCCESS, payload: response?.data });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_ALL_CONTRACTS_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

/**
 * get all new contracts
 */
export const getAllNewContractAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_ALL_NEW_CONTRACTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getDocuSigns",
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_ALL_NEW_CONTRACTS_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_ALL_NEW_CONTRACTS_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

/**
 * get all under review contracts
 */
export const getUnderReviewContractAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_UNDER_REVIEW_CONTRACTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getDocuSigns",
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_UNDER_REVIEW_CONTRACTS_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_UNDER_REVIEW_CONTRACTS_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

/**
 * get all verified contracts
 */
export const getAllVerifiedContractAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_ALL_VERIFIED_CONTRACTS_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getDocuSigns",
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_ALL_VERIFIED_CONTRACTS_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_ALL_VERIFIED_CONTRACTS_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// discard contracts
export const discardContractRequest = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: DISCARD_CONTRACT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "deleteDocuSign",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: DISCARD_CONTRACT_SUCCESS, payload: response?.data });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DISCARD_CONTRACT_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// attach file to contract
export const attachFileToContract = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ATTACH_FILE_TO_CONTRACT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "uploadDocuSignAttachment",
      params: payload?.params,
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: ATTACH_FILE_TO_CONTRACT_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ATTACH_FILE_TO_CONTRACT_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * add contract action
 */
export const addNewContractAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_NEW_CONTRACT_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "addDocuSign",
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: ADD_NEW_CONTRACT_SUCCESS });
      if (successCallback) successCallback(response);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_NEW_CONTRACT_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * edit contarct action
 */
export const editContractAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_CONTRACT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "editDocuSign",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: EDIT_CONTRACT_SUCCESS });
      if (successCallback) successCallback(response);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: EDIT_CONTRACT_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * update contract status
 */
export const updateContractStatusAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_CONTRACT_STATUS_REQUEST });
    const { response, error } = await apiRequest({
      method: "PATCH",
      url: "updateDocuSignStatus",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({ type: UPDATE_CONTRACT_STATUS_SUCCESS });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: UPDATE_CONTRACT_STATUS_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * add signature to contarct action
 * example: http://localhost:8000/mobile/api/v3/addSignature?id=6835b30a27f8c057262a24ca
 */
export const addSignatureToContractAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: ADD_SIGNATURE_TO_CONTRACT_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "addSignature",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: ADD_SIGNATURE_TO_CONTRACT_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_SIGNATURE_TO_CONTRACT_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * add signature action
 * example: http://localhost:8000/api/v3/addSignatureFileText
 */
export const addSignatureAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch, getState) => {
    const contractPreset = getState()?.contract?.contractPresets;
    dispatch({ type: ADD_SIGNATURE_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "addSignatureFileText",
      data: payload?.data,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: ADD_SIGNATURE_SUCCESS,
        payload: {
          savedText:
            response?.data?.data?.text?.savedText ??
            contractPreset?.savedText ??
            [],
          savedSignature:
            response?.data?.data?.signature?.savedSignature ??
            contractPreset?.savedSignature ??
            [],
        },
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: ADD_SIGNATURE_FAILURE });
      dispatch(
        alertDialogAciton({
          open: true,
          title: "Error",
          message: error?.response?.data?.message,
        }),
      );
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * add signature action
 * example: http://localhost:8000/api/v3/editSignatureFile?fileId=6837248b388988d76b50434a&textId=6837248b388988d76b504349
 */
export const editSignatureAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: EDIT_SIGNATURE_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "editSignatureFile",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: EDIT_SIGNATURE_SUCCESS,
        payload: {
          savedText: response?.data?.data?.savedText,
          savedSignature: response?.data?.data?.savedSignature,
        },
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: EDIT_SIGNATURE_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * delete signature action
 * example: http://localhost:8000/api/v3/deleteSignature?fileId=6837248b388988d76b50434a&textId=6837248b388988d76b504349
 */
export const deleteSignatureAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_SIGNATURE_REQUEST });
    const { response, error } = await apiRequest({
      method: "PUT",
      url: "deleteSavedSignature",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: DELETE_SIGNATURE_SUCCESS,
        payload: {
          savedText: response?.data?.data?.text?.savedText,
          savedSignature: response?.data?.data?.signature?.savedSignature,
        },
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: DELETE_SIGNATURE_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

/**
 * get signature
 * example:
 */
export const getSignatureAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: GET_SIGNATURE_REQUEST });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getSavedSignatures",
      data: payload?.data,
      params: payload?.params,
      isToken: true,
    });
    if (response?.status === 200) {
      dispatch({
        type: GET_SIGNATURE_SUCCESS,
        payload: {
          savedText: response?.data?.data?.savedText,
          savedSignature: response?.data?.data?.savedSignatures,
        },
      });
      if (successCallback) successCallback(response?.data?.message);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: GET_SIGNATURE_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};